export default (props, e) => {
	e.preventDefault();
	const eventsCalendarEl = document.querySelector('[data-is="RangeDatepicker"]');
	const eventsCalendarComponentElement = document.getElementById(eventsCalendarEl.id);
	eventsCalendarComponentElement.click();
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/openDatepicker.js